import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Shield } from "lucide-react";
import { useT } from "../lib/i18n";
import LanguageToggle from "./LanguageToggle";

export default function Header({ floating = false }) {
    const { t } = useT();
    const { pathname } = useLocation();
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const check = () => setIsAdmin(!!localStorage.getItem("sc_admin_token"));
        check();
        window.addEventListener("storage", check);
        return () => window.removeEventListener("storage", check);
    }, []);

    return (
        <header
            className={`fixed top-0 left-0 right-0 z-40 transition-all duration-500 ${
                floating ? "bg-transparent" : "glass-strong"
            }`}
            data-testid="site-header"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-12 h-16 flex items-center justify-between">
                <Link to="/" className="flex items-center gap-3" data-testid="logo-link">
                    <span className="w-2 h-2 rounded-full bg-gold animate-pulse" />
                    <span className="font-serif text-xl tracking-wide text-ink-primary">ScottsClub</span>
                </Link>

                <nav className="hidden md:flex items-center gap-8 text-[12px] tracking-[0.22em] uppercase">
                    <Link
                        to="/join"
                        className={`transition-colors hover:text-gold ${pathname === "/join" ? "text-gold" : "text-ink-secondary"}`}
                        data-testid="nav-join"
                    >{t("nav.join")}</Link>
                    <Link
                        to="/member"
                        className={`transition-colors hover:text-gold ${pathname.startsWith("/member") ? "text-gold" : "text-ink-secondary"}`}
                        data-testid="nav-member"
                    >{t("nav.member")}</Link>
                </nav>

                <div className="flex items-center gap-4">
                    {isAdmin && (
                        <Link
                            to="/admin"
                            data-testid="nav-admin"
                            aria-label="Admin"
                            className="inline-flex items-center gap-1.5 px-3 py-1.5 border border-gold/40 text-gold rounded-sm hover:bg-gold/10 hover:border-gold/70 text-[11px] tracking-[0.22em] uppercase transition-colors"
                        >
                            <Shield size={13} />
                            <span className="hidden sm:inline">Admin</span>
                        </Link>
                    )}
                    <LanguageToggle />
                </div>
            </div>
            <div className="gold-divider opacity-30" />
        </header>
    );
}
